module.exports = __webpack_public_path__ + "img/prize.e7384643.svg";